module.exports = __webpack_public_path__ + "media/1.36a212f8.mp4";